<div class="card" [ngClass]="'card--' + variant">
    <div class="card-header" *ngIf="!hideHeader">
        <div class="flex-grow-0 flex-shrink-0">
            <ng-content select="[header-left-actions]"></ng-content>
        </div>
        <div class="flex-grow-0 flex-shrink-0" *ngIf="collapsable">
            <app-button iconName="chevron-right" *ngIf="collapsed" (clickEvent)="collapsed = !collapsed; collapsedChangedEvent.emit(collapsed)"></app-button>
            <app-button iconName="chevron-down" *ngIf="!collapsed" (clickEvent)="collapsed = !collapsed; collapsedChangedEvent.emit(collapsed)"></app-button>
        </div>
        <div class="card-header-title flex-grow-1">
            {{title}}
        </div>
        <div class="card-header-actions flex-grow-0 flex-shrink-0 d-flex align-items-center">
            <ng-container *ngIf="counter && counter >= 0">({{counter}})</ng-container>
            <ng-content select="[header-actions]"></ng-content>
            <app-button iconName="refresh" (clickEvent)="refreshEvent.emit()" *ngIf="displayRefreshButton"></app-button>
        </div>
    </div>
    <div #cardContent class="card-content" [style.max-height.px]="contentExpanded ? defaultMaxContentHeight : contentMaxHeight">
        <ng-content select="[card-collpased-content]"></ng-content>

        <ng-container *ngIf="!collapsed">
            <ng-container *ngIf="!contentLoading">
                <ng-content></ng-content>
            </ng-container>
            <div class="text-center" *ngIf="contentLoading">
                <app-loading [showText]="false"></app-loading>
            </div>
        </ng-container>
    </div>
    <div class="card-content-expandable text-center p-x-12" *ngIf="contentMaxHeight !== defaultMaxContentHeight">
        <app-button iconName="chevron-down" *ngIf="!contentExpanded && displayContentExpandButton" (clickEvent)="contentExpanded = true"></app-button>
        <app-button iconName="chevron-up" *ngIf="contentExpanded" (clickEvent)="contentExpanded = false"></app-button>
    </div>
    <div class="card-footer d-flex align-items-center" *ngIf="(!collapsed || footerVisibleEventCollapsed) && (footerActions?.length > 0 || footerMains?.length > 0)">
        <div class="flex-grow-1">
            <ng-content select="[footer-main]"></ng-content>
        </div>
        <div class="card-footer-actions">
            <ng-content select="[footer-actions]"></ng-content>
        </div>
    </div>
</div>
